import React, { useState, useEffect } from "react";
import logo from "../assets/images/celdon-logo.png";
import login from "../assets/images/login.jpg";
// Import your CSS file for styling
import { Alert, Form, FormGroup } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { Link, useNavigate } from "react-router-dom";
import "../assets/Login.css";
import axios from "axios";
import { Base_Url } from "../BaseUrl";
import { Bars } from "react-loader-spinner";

function Login() {
  const [animate, setAnimate] = useState(false);
  const [mobile, setmobile] = useState("");
  const [loading, setloading] = useState(false);
  const [otp, setotp] = useState("");
  const [otpbox, setotpbox] = useState(false);
  const [checkotp, setcheckotp] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [submitalert, setsubmitalert] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Add a delay to start the animation after the component mounts
    const animationTimeout = setTimeout(() => {
      setAnimate(true);
    }, 100);

    return () => {
      clearTimeout(animationTimeout);
    };
  }, []);
  const handlenumber = async (event) => {
    event.preventDefault();
    setloading(true)

    try {
      const response = await axios.post(`${Base_Url}/login`, {
        phone: mobile,
      });
      // setotp(response.data.otp);
      setcheckotp(response.data.otp);
      setStatus(response.data.status);
      if (response.data.status == "New") {
        setsubmitalert(true);

        setTimeout(() => {
          setsubmitalert(false);
        }, 2000);
      }
      // console.log(response.data.message);
      setotpbox(true);
      if (response.data.error === 201 || 200) {
        setIsClicked(true);

      }
      // alert(response.data.message)
    } catch (error) {
      console.error(error);
    } finally {
      setloading(false)
    }
  };

  const handleverify = (e) => {
    setloading(true);
    e.preventDefault();
    if (status !== "New" && Number(otp) == Number(checkotp)) {
      axios
        .post(`${Base_Url}/verify_otp`, { phone: mobile, otp: otp })
        .then((res) => {
          if (res.data !== null) {
            const token = res.data.token;
            localStorage.setItem("token", token);
            navigate("/dash");
            setloading(false);
          }
        })
        .catch((error) => {
          // Handle error if the axios request fails
          console.error("Error during OTP verification:", error);
          setloading(false);
        });
    } else {
      setsubmitalert(true);
      setTimeout(() => {
        setsubmitalert(false);
        setotp("");
      }, 1000);
      setloading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <section className=" loginpage">
        <div className={`container box1 ${animate ? "animate" : ""}`}>
          <div className="row align-items-center justify-content-center ">
            {/* <div className="col-md-12">
              <div className="">
                <h3 className="bg-white shadow text-center ">Login</h3>
              </div>
            </div> */}
            {/* <div className={`col-md-6 `}>
              <div
                className={`h-100 animate-left ${
                  animate ? "slide-in-left" : ""
                }`}
              >
                <img src={login} className="img-fluid rounded-4" alt="" />
              </div>
            </div> */}
            {submitalert && (
              <div className="col-md-12">
                <div className="row align-items-center justify-content-center">
                  <div className="col-md-4">
                    <Alert
                      variant="danger"
                      className="text-center mt-3 fw-bold"
                    >
                      {status == "New"
                        ? "You Have not access to Admin Panel"
                        : " Otp in Incorrect"}
                    </Alert>
                  </div>
                </div>
              </div>
            )}
            <div className={`col-md-4`}>
              <div
                className={`loginbox d-flex align-items-center justify-content-center w-100 p-4 shadow  rounded-3 animate-right ${animate ? "slide-in-right" : ""
                  }`}
              >
                <div className="w-100">
                  <div className="d-flex justify-content-center">
                    <div
                      className="  bg-white shadow  p-3 rounded-3"
                      style={{ width: "max-content" }}
                    >
                      <img
                        src={logo}
                        style={{ height: "50px" }}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <Form
                    className="px-md-4 px-2 pt-4 mt-5 "
                    onSubmit={otp ? handleverify : handlenumber}
                  >
                    <FormGroup className="mb-2">
                      <label htmlFor="">Enter Mobile Number</label>
                      <input
                        type="number"
                        className="form-control"
                        value={mobile}
                        // onChange={(e) => setmobile(e.target.value)}
                        onChange={(e) => {
                          const input = e.target.value;
                          // Use a regular expression to allow only numeric digits
                          const numericInput = input.replace(/\D/g, "");
                          // Limit the input to 10 characters
                          const truncatedInput = numericInput.slice(0, 10);
                          setmobile(truncatedInput);
                        }}
                      />
                    </FormGroup>
                    {checkotp && status !== "New" && (
                      <FormGroup className="mt-3 OtpBox">
                        <label className="mb-1 fw-bold" htmlFor="otp">
                          OTP
                        </label>

                        <OtpInput
                          value={status == "New" ? "" : otp}
                          onChange={setotp}
                          numInputs={4}
                          className="form-control "
                          renderSeparator={<span className="me-2"> </span>}
                          renderInput={(props) => <input {...props} />}
                        />
                      </FormGroup>
                    )}
                    {/* {checkotp && status !== "New" && (
                      <Alert
                        variant="success"
                        className="text-center mt-3 fw-bold"
                      >
                        Otp: {checkotp}
                      </Alert>
                    )} */}
                    <button className="btn bg-warning mt-3 w-100 text-white">
                      Submit
                    </button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
